// extracted by mini-css-extract-plugin
export default {"badge":"approval_status_badge-module___badge___bac75371"};